export const END_CARD_SPARK_BURST_EVENT = 'end-card-spark-burst'
export const END_CARD_SPARK_REVEAL_EVENT = 'end-card-spark-reveal'
